import { render, staticRenderFns } from "./NumbersWidget.vue?vue&type=template&id=7bef1b66&scoped=true&"
import script from "./NumbersWidget.vue?vue&type=script&lang=js&"
export * from "./NumbersWidget.vue?vue&type=script&lang=js&"
import style0 from "./NumbersWidget.vue?vue&type=style&index=0&id=7bef1b66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bef1b66",
  null
  
)

export default component.exports